/** Collapse a person-name fragment for fuzzy comparison (case, spaces, apostrophes). */
export function normalizeNamePart(value) {
    return value
        .trim()
        .toLowerCase()
        .replace(/[''`]/g, "")
        .replace(/[^a-z0-9]+/g, "");
}
/**
 * Detect when firstName appears to contain all or part of lastName — e.g.
 * firstName "Jack O'Brien" with lastName "O Brien".
 */
export function firstNameAppearsToIncludeLastName(firstName, lastName) {
    const first = firstName.trim();
    const last = lastName.trim();
    if (!first || !last)
        return false;
    const normalizedLast = normalizeNamePart(last);
    if (normalizedLast.length < 2)
        return false;
    const normalizedFirst = normalizeNamePart(first);
    if (normalizedFirst === normalizedLast)
        return false;
    if (normalizedFirst.includes(normalizedLast))
        return true;
    const parts = first.split(/\s+/).filter(Boolean);
    if (parts.length < 2)
        return false;
    const suffix = normalizeNamePart(parts.slice(1).join(" "));
    if (!suffix)
        return false;
    return (suffix === normalizedLast ||
        normalizedLast.includes(suffix) ||
        suffix.includes(normalizedLast));
}
export function firstNameOnlyValidationMessage() {
    return "Enter your first name only — your last name is collected in the next field.";
}
/**
 * Split a single full-name string into first/last parts. The last whitespace
 * token becomes the last name; everything before it (including middle names)
 * becomes the first name. Used to keep firstName/lastName populated downstream
 * now that the identity step collects a single Full Name field.
 */
export function splitFullName(fullName) {
    const parts = fullName.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0)
        return { firstName: "", lastName: "" };
    if (parts.length === 1)
        return { firstName: parts[0], lastName: "" };
    return {
        firstName: parts.slice(0, -1).join(" "),
        lastName: parts[parts.length - 1],
    };
}
